export default "__VITE_ASSET__Bby6C8m4__"